const KLARNA_ORDER_ITEM_NAME = {
    SALES_TAX: 'Sales Tax',
    DISCOUNT: 'Discount',
};

export default KLARNA_ORDER_ITEM_NAME;
